import { useState, useEffect } from 'react';

export const useMapLocation = ({
  responseZipCode,
  responseMunicipality,
  statesData,
  municipalityAction,
  neighborhoodAction,
  responseNeighborhoodLocation,
  onLocationChange, // Añadir onLocationChange aquí
}) => {
  const [mapLocation, setMapLocation] = useState({
    latitude: null,
    longitude: null,
  });

  useEffect(() => {
    if (
      responseZipCode &&
      responseZipCode.neighborhoods &&
      responseZipCode.neighborhoods.length > 0
    ) {
      const { latitude, longitude } = responseZipCode.neighborhoods[0];
      setMapLocation({ latitude, longitude });
      onLocationChange(latitude, longitude);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [responseZipCode]);

  useEffect(() => {
    if (responseNeighborhoodLocation) {
      const { payload } = responseNeighborhoodLocation;
      const { lat, lng } = payload || {};
      setMapLocation({ latitude: lat, longitude: lng });
      if (onLocationChange) {
        onLocationChange(lat, lng);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [responseNeighborhoodLocation]);

  const handleLocationChange = (latitude, longitude) => {
    setMapLocation({ latitude, longitude });
    if (onLocationChange) {
      onLocationChange(latitude, longitude);
    }
  };

  const handleStateSelect = (stateId) => {
    const selectedState = statesData.find((state) => state.id === stateId);
    if (selectedState) {
      setMapLocation({
        latitude: selectedState.latitude,
        longitude: selectedState.longitude,
      });
      if (onLocationChange) {
        onLocationChange(selectedState.latitude, selectedState.longitude);
      }
    }
    municipalityAction({ state_id: stateId });
  };

  const handleMunicipalitySelect = (municipalityId) => {
    const selectedMunicipality = responseMunicipality.find(
      (municipality) => municipality.id === municipalityId,
    );
    if (selectedMunicipality) {
      setMapLocation({
        latitude: selectedMunicipality.latitude,
        longitude: selectedMunicipality.longitude,
      });
      if (onLocationChange) {
        onLocationChange(selectedMunicipality.latitude, selectedMunicipality.longitude);
      }
    }
    neighborhoodAction({ municipality_id: municipalityId });
  };

  const handleNeighborhoodSelect = (neighborhood) => {
    if (neighborhood && neighborhood.latitude && neighborhood.longitude) {
      const { latitude, longitude } = neighborhood;
      setMapLocation({ latitude, longitude });
      if (onLocationChange) {
        onLocationChange(latitude, longitude);
      }
    }
  };

  return {
    mapLocation,
    handleLocationChange,
    handleStateSelect,
    handleMunicipalitySelect,
    handleNeighborhoodSelect,
  };
};
